<template>
  <div class="product-modificators">
    <component
        v-for="mod in modificatorsFiltered"
        :key="mod.ID"
        :is="mod.PRODUCT_COMPONENT"
        v-bind="mod.PRODUCT_COMPONENT_PROPS"
        :style="mod.PRODUCT_COMPONENT_STYLE"
        :modificator="mod"
        :model-value="basketItem.getModificatorValue(mod)"
        @update:model-value="basketItem.setModificatorValue(mod, $event)"
        @click.native.stop.prevent=""
    />
  </div>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";
import {Modificator} from "@/gql/gen";
import {BasketItemModel} from "@/modules/shop/composable/useBasketItemModel";
import {useDebugComponent} from "@/core/composable/useDebugComponent";

const props = withDefaults(defineProps<{
  modificators: Modificator[] | Record<string, Modificator>,
  include?: (string | number)[],
  exclude?: (string | number)[],
  basketItem: BasketItemModel
}>(), {
  include: () => [],
  exclude: () => [],
})

const {include, exclude} = props
const {modificators} = toRefs(props)

const modificatorsFiltered = computed(() => {
  const modificatorsList = Array.isArray(modificators.value) ? modificators.value : Object.values(modificators.value)
  return modificatorsList.filter(item =>
      (!include.length || include.includes(item.CODE_PATH) || include.includes(item.GROUP_CODE) || include.includes(item.ID.toString()))
      && (!exclude.length || !exclude.includes(item.CODE_PATH) || !exclude.includes(item.GROUP_CODE) || !exclude.includes(item.ID.toString()))
  )
})

// Debug композабл для отслеживания ререндеров
useDebugComponent('ProductModificators', { collectRenders: true });

</script>

<style scoped lang="scss">

</style>
